<template>
	<ProductListContent :initial-company-id="effectiveCompanyId" :initial-category-title="categoryName" />
</template>

<script setup>
import { computed } from 'vue';
import ProductListContent from '@/pages/productList/ProductListContent.vue';
import { queryWebsiteByCompanyId } from '@/api/index.js';
import { getCategoryLabel } from '#shared/classifyConstants';

const route = useRoute();
const categoryDetailTitleState = useState(`category-detail-title:${route.fullPath}`, () => '');

const effectiveCompanyId = computed(() => route.params.companyId ?? route.query.companyId ?? '1');
const productnature = computed(() => route.params.productnature ?? null);
const isMainSite = computed(() => String(effectiveCompanyId.value) === '1');

const { data: websiteInfo } = await useAsyncData(
	() => `website-classifyList-${effectiveCompanyId.value}`,
	() => queryWebsiteByCompanyId(effectiveCompanyId.value),
	{ watch: [effectiveCompanyId] }
);

const companyFullName = computed(() => {
	const site = websiteInfo.value?.data;
	return site?.fullName || site?.companyName || site?.websiteName || '国械在线';
});
const province = computed(() => {
	const site = websiteInfo.value?.data;
	return site?.province || site?.provinceName || site?.provinceStr || site?.provincename || '';
});
const seoCompanyName = computed(() => (isMainSite.value ? '国械在线' : companyFullName.value));

const categoryName = computed(() => categoryDetailTitleState.value || getCategoryLabel(productnature.value) || '分类详情');

const title = computed(() => {
	const cat = categoryName.value;
	return isMainSite.value ? `${cat}价格|参数 - 正品${cat}品牌 - 国械在线` : `${cat}价格|参数 - 正品${cat}多品牌采购 - ${seoCompanyName.value}`;
});

const description = computed(() => {
	const cat = categoryName.value;
	if (isMainSite.value) {
		return `国械在线${cat}专区，提供涵盖多品牌厂家的正品${cat}，所有商品均具备医疗器械注册证或备案凭证。支持医院、药店及企业客户按品牌、参数在线比价与批量采购。`;
	}
	return `${
		seoCompanyName.value
	}官方直营${cat}专区，提供涵盖多品牌厂家的正品${cat}，所有商品均具备医疗器械注册证或备案凭证。支持医院、药店及企业客户按品牌、参数在线比价与批量采购，服务${
		province.value || '所属省级行政区'
	}地区。`;
});

const keywords = computed(() => {
	const cat = categoryName.value;
	return `${cat}价格,${cat}参数,${cat}品牌,${cat}厂家,${seoCompanyName.value}`;
});

useHead(() => ({
	title: title.value,
	meta: [
		{ name: 'description', content: description.value, tagPriority: 10 },
		{ name: 'keywords', content: keywords.value, tagPriority: 10 },
	],
}));
</script>
